import { Box, Typography } from '@mui/material';

import { Location as LocationDto } from '@/common/apis/dtos';
import { formatAddress  } from '@/common/utilities/display-utilities';

export function Location(props: LocationDto) {
  const { physicalAddress } = props;

  return (
    <Box>
      <Typography component="div" variant="h3" fontSize={16} color="typography.highEmphasis">
        <div className="fs-mask">{props.name}</div>
      </Typography>

      <Typography component="div" variant="body1" color="typography.highEmphasis" fontWeight={400}>
        <Box data-testid="address">
          {formatAddress(physicalAddress ?? {})}
        </Box>
      </Typography>
    </Box>
  );
}
